import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import Select, { AriaOnFocus } from "react-select";
import {
  getPartyApi,
  getUnitAPI,
  getExpressInwardApi, // Add correct API for Express Inward list
} from "api";
import AsyncSelect from "react-select/async";
// import partyImage from '../../../public/images/dashboard-images/partyLogo.svg'

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment/moment";
import { withTranslation } from "react-i18next";
import Barcode from "react-barcode";

export const outWardStatus = [
  { label: "All", value: "" },
  { label: "Pending", value: "1" },
  { label: "Data Entry Accepted", value: "2" },
  { label: "Partially Completed", value: "4" },
  { label: "Completed", value: "5" },
  { label: "Closed", value: "7" },
];
 const DateFilter = [
  { label: "Entry Date", value: "entrydate" },
  { label: "Last Outward Date", value: "partylastoutwarddate" },
];
class ExpressInwardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 100,
      totalSize: 0,
      selectedPartyDetails: null,
      partyId: "",
      factoryId: "",
      jangadId: "",
      outWardStatus: "",
      fromDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
      factoryList: [],
      orderList: [],
      stockList: [],
      partyList: [],
      showBarcodeModal: false,
      selectedJangadId: null,
      selectedJangad: null,
      scannedBarcode: "", // New state for barcode input
      dateFilterType: "",
    };
    this.barcodeRef = React.createRef();
  }
  toggleBarcodeModal = (jangad = null) => {
    this.setState(prevState => ({
      showBarcodeModal: !prevState.showBarcodeModal,
      selectedJangadId: jangad ? jangad.id : null,
      selectedJangad: jangad,
    }));
  };
  async componentDidMount() {
    this.setState(
      {
        partyId: localStorage.getItem("sales_filter_partyId") || "",
        fromDate:
          localStorage.getItem("sales_filter_fromDate") ||
          moment().subtract(6, "days").format("YYYY-MM-DD"),
        toDate:
          localStorage.getItem("sales_filter_toDate") ||
          moment().format("YYYY-MM-DD"),
        jangadId: localStorage.getItem("sales_filter_jangadId") || "",
        outWardStatus: localStorage.getItem("sales_filter_outWardStatus") || "",
        factoryId: localStorage.getItem("sales_filter_factoryId") || "",
        dateFilterType:
          localStorage.getItem("sales_filter_dateFilterType") || "",
      },
      () => this.getStockList()
    );

    const partyList = await getPartyApi({});
    if (partyList && partyList.data && Array.isArray(partyList.data.parties)) {
      this.setState({ partyList: partyList.data.parties });
    }
    const factoryList = await getUnitAPI({});
    if (
      factoryList &&
      factoryList.data &&
      Array.isArray(factoryList.data.factories)
    ) {
      this.setState({
        factoryList: factoryList.data.factories,
      });
    }
    await this.getStockList(); // Load data on mount
    await this.getJangadList(null, this.state.partyId); // Load Jangad list
  }
  setParty = value => {
    this.setState({
      selectedPartyDetails: value,
    });
  };
  async getStockList() {
    // Use Express Inward API
    const stockList = await getExpressInwardApi({
      page: this.state.page,
      limit: this.state.sizePerPage,
      partyId: this.state.partyId,
      jangadId: this.state.jangadId,
      factoryId: this.state.factoryId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      outWardStatus: this.state.outWardStatus, // Add this line
      dateFilterType: this.state.dateFilterType,
      // Add more filters if your API supports them
    });
    if (stockList && stockList.data) {
      this.setState({
        totalSize: stockList.data.count || 0,
        stockList:
          Array.isArray(stockList.data.expressInwards) &&
          stockList.data.expressInwards.length > 0
            ? stockList.data.expressInwards
            : [],
      });
    }
  }
  async getFactoryList(inputValue) {
    const data = await getUnitAPI({
      isInternal: null,
      name: null,
      page: null,
      limit: null,
    });
    if (data && data.data && Array.isArray(data.data.factories)) {
      this.setState({
        factoryList: data.data.factories,
      });
      const allFactories = data.data.factories;
      const filtered = inputValue
        ? allFactories.filter(factory =>
            (factory.name || "")
              .toLowerCase()
              .includes(inputValue.toLowerCase())
          )
        : allFactories;
      return filtered.map(factory => ({
        label: factory.name,
        value: factory.id,
      }));
    }
    return this.state.factoryList.map(x => {
      return { label: x.name, value: x.id };
    });
  }
  formatPartyCode = code => {
    if (!code) return "";
    const cleaned = code.replace(/^PARTY/i, "");
    const numeric = Number(cleaned);
    if (!isNaN(numeric)) {
      return numeric.toString().padStart(3, "0");
    }
    return cleaned;
  };
  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: null,
      limit: null,
      name: null,
      partyCode: null, // Don't filter on server
    });
    if (data && data.data && Array.isArray(data.data.parties)) {
      this.setState({
        partyList: data.data.parties,
      });
      const allParties = data?.data?.parties || [];
      const filtered = inputValue
        ? allParties.filter(party => {
            const name = (party.name || "").toLowerCase();
            const code = (
              this.formatPartyCode(party.partyCode) || ""
            ).toLowerCase();
            const combined = `${code} - ${name}`.toLowerCase();
            const search = inputValue
              .toLowerCase()
              .replace(/\s+/g, "")
              .replace(/-/g, "");
            return (
              name.includes(search) ||
              code.includes(search) ||
              combined.replace(/\s+/g, "").replace(/-/g, "").includes(search)
            );
          })
        : allParties;

      return filtered.map(x => ({
        label: `${this.formatPartyCode(x.partyCode)} - ${x.name}`,
        value: x.id,
      }));
    }

    return this.state.partyList.map(x => ({
      label: `${this.formatPartyCode(x.partyCode)} - ${x.name}`,
      value: x.id,
    }));
  }

  async getJangadList(inputValue) {
    const data = await getExpressInwardApi({
      page: null,
      limit: null,
      name: null,
    });

    if (data && data.data && Array.isArray(data.data.expressInwards)) {
      const allOptions = data.data.expressInwards.map(x => ({
        label: x.jangadId,
        value: x.jangadId,
      }));

      const filteredOptions = inputValue
        ? allOptions.filter(opt =>
            opt.label.toLowerCase().includes(inputValue.toLowerCase())
          )
        : allOptions;

      const finalOptions = inputValue ? filteredOptions : allOptions;

      this.setState({ orderList: finalOptions });
      return finalOptions;
    }
  }
  handleBarcodeScan = async e => {
    const scannedValue = e.target.value.trim(); // Trim whitespace
    this.setState({ scannedBarcode: scannedValue });

    if (scannedValue) {
      const stockList = this.state.stockList;
      const matchedInward = stockList.find(
        item => `JANGAD${item.id}` === scannedValue // Match with `JANGAD${item.id}`
      );
      if (matchedInward) {
        setTimeout(() => {
        this.props.history.push({
          pathname: "/sales-view-express-inward",
          query: { data: matchedInward },
        });
      }, 1000);
      } else {
        // alert(`Invalid barcode: ${scannedValue}. No matching inward found.`);
      }
    }
  };

  resetAll = async () => {
    // Clear localStorage filter values
    localStorage.removeItem("sales_filter_partyId");
    localStorage.removeItem("sales_filter_fromDate");
    localStorage.removeItem("sales_filter_toDate");
    localStorage.removeItem("sales_filter_jangadId");
    localStorage.removeItem("sales_filter_outWardStatus");
    localStorage.removeItem("sales_filter_factoryId");
    localStorage.removeItem("sales_filter_dateFilterType");

    // Reset state to defaults
    await this.setState(
      {
        partyId: "",
        jangadId: "",
        factoryId: "",
        outWardStatus: "",
        dateFilterType: null,
        fromDate: moment().subtract(6, "days").format("YYYY-MM-DD"),
        toDate: moment().format("YYYY-MM-DD"),
        scannedBarcode: "",
        page: 1,
        sizePerPage: 100,
        stockList: [],
      },
      () => this.getStockList()
    );
  };

  // Refresh list without clearing filters or barcode input
  refreshList = async () => {
    this.setState(
      {
        stockList: [],
        page: 1,
      },
      () => this.getStockList()
    );
  };

  render() {
    const formatNumber = num => {
      if (num == null) return "0";
      return Number.isInteger(num) ? num : Number(num).toFixed(2);
    };
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const promiseOptionsOrder = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getJangadList(inputValue, this.state.partyId));
        }, 0);
      });
    const promiseOptionsFactory = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getFactoryList(inputValue));
        }, 0);
      });
    this.columns1 = [
      {
        dataField: "sr",
        text: "#",
        sort: true,
        formatter: (cell, row, rowIndex) => {
          return (this.state.page - 1) * this.state.sizePerPage + rowIndex + 1;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "action",
        text: `${this.props.t("Action")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            {row.status === "Pending" && ( // Allow edit when status is 1 (Pending)
              <Link
                to={{
                  pathname: "/user-add-express-inward",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" alt="Edit" />
                </button>
              </Link>
            )}
            <Link
              to={{
                pathname: "/sales-view-express-inward",
                query: {
                  data: row,
                },
              }}
            >
              <button className="py-2 px-2 ms-2 border-0 rounded">
                <img src="images/dashboard-images/view.svg" alt="View" />
              </button>
            </Link>
            <button
              className="py-2 px-2 ms-2 border-0 rounded"
              title="Print Barcode"
              onClick={() => this.toggleBarcodeModal(row)}
            >
              <img
                src="images/dashboard-images/print.svg"
                alt="Print Barcode"
              />
            </button>
          </div>
        ),
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "jangadId",
        text: `${this.props.t("J.ID")}`,
        sort: true,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "partyId",
        text: `${this.props.t("P. Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.party
            ? `${this.formatPartyCode(row.party.partyCode)} - ${row.party.name}`
            : row.partyId;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "noOfPieces",
        text: `${this.props.t("T. Pcs.")}`,
        sort: true,
        formatter: (cell, row) => {
          const remainingPieces = row.noOfPieces - row.partyOutwardPieces;
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ "margin-right": "5px" }}>{row.noOfPieces}</div>
              <div className="text-success">({remainingPieces || 0})</div>
            </div>
          );
        },
        footer: () => {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ marginRight: "5px" }}>
                T. Pcs: {totals.totalPieces}
              </div>
              <div className="text-success">({totals.remainingPieces})</div>
            </div>
          );
        },
      },
      {
        dataField: "totalWeight",
        text: `${this.props.t("T. Weight")}`,
        sort: true,
        formatter: (cell, row) => {
          const totalWeight = formatNumber(row.totalWeight);
          const remainingWeight = row.totalWeight - row.partyOutwardWeight;
          const formattedRemaining = formatNumber(remainingWeight);
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ marginRight: "5px" }}>{totalWeight}</div>
              <div className="text-success">({formattedRemaining || 0})</div>
            </div>
          );
        },
        footer: () => {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ marginRight: "5px" }}>
                T. Weight: {totals.totalWeight}
              </div>
              <div className="text-success">({totals.remainingWeight})</div>
            </div>
          );
        },
      },
      {
        dataField: "status",
        text: `${this.props.t("Status")}`,
        sort: true,
        formatter: (cell, row) => row.status,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "deliveredPiecesWeight",
        text: `${this.props.t("D. Pcs. / D. Weight")}`,
        sort: true,
        formatter: (cell, row) =>
          `${row.partyOutwardPieces} / ${formatNumber(row.partyOutwardWeight)}`,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "lastDeliveredYet",
        text: `${this.props.t("D. Date")}`,
        sort: true,
        formatter: (cell, row) =>
          row.partyLastDeliveredYet
            ? moment(row.partyLastDeliveredYet).format("DD/MM/YYYY")
            : "",
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "salesRemark",
        text: `${this.props.t("Sales Remark")}`,
        sort: true,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "returnedPiecesWithoutProcess",
        text: `${this.props.t("Return Pcs.")}`,
        sort: true,
        formatter: (cell, row) => row.noOfReturnedPiecesWithoutProcessed,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "inProcessPieces",
        text: `${this.props.t("In Process Pcs.")}`,
        sort: true,
        formatter: (cell, row) => row.salesInProcess,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "pendingPiecesForApproval",
        text: `${this.props.t("App. Pending Pcs.")}`,
        sort: true,
        formatter: (cell, row) => row.pendingPeicesForApproval,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "categoryId",
        text: `${this.props.t("Category")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.category.name;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "unitId",
        text: `${this.props.t("U. Name")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.factory ? row.factory.name : row.unitId;
        },
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        sort: true,
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Entry Date")}`,
        sort: true,
        formatter: (cell, row) => moment(row.createdAt).format("DD/MM/YYYY"),
        footer: () => {
          return <div></div>;
        },
      },
      {
        dataField: "deliveryBoyName",
        text: `${this.props.t("D. Person")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.deliveryBoy ? row.deliveryBoy.name : row.deliveryBoyName;
        },
        footer: () => {
          return <div></div>;
        },
      },
    ];
    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getStockList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getStockList()
                );
              }}
              style={{ color: "red" }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
      sizePerPage: this.state.sizePerPage,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "manage stock";

    const printBarcodeOnly = () => {
      const barcodeEl = this.barcodeRef.current;

      if (!barcodeEl) {
        alert("Barcode content is not ready.");
        return;
      }
      const printContents = barcodeEl.outerHTML;

      const printWindow = window.open("", "", "width=300,height=300");

      printWindow.document.write(`
    <html>
      <head>
        <title>Print Barcode</title>
         <style>
          body {
            margin: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        </style>
      </head>
      <body>
        ${printContents}
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            }
          }
        </script>
      </body>
    </html>
  `);
      printWindow.document.close();
    };
    const rowClasses = (row, rowIndex) => {
      const endTime = row.completedAt ? new Date(row.completedAt) : new Date();
      const startTime = new Date(row.createdAt);
      const durationMs = endTime - startTime; // difference in ms
      const durationHours = durationMs / (1000 * 60 * 60); // convert ms to hours

      if (durationHours > 36) return "red-bg";
      if (durationHours > 24) return "yellow-bg";
      return "";
    };

    // Calculate totals for footer
    const calculateTotals = () => {
      let totalPieces = 0;
      let totalWeight = 0;
      let remainingPiecesTotal = 0;
      let remainingWeightTotal = 0;

      this.state.stockList.forEach(item => {
        totalPieces += Number(item.noOfPieces) || 0;
        totalWeight += Number(item.totalWeight) || 0;

        // Calculate remaining pieces and weight
        const remainingPieces =
          (Number(item.noOfPieces) || 0) -
          (Number(item.partyOutwardPieces) || 0);
        const remainingWeight =
          (Number(item.totalWeight) || 0) -
          (Number(item.partyOutwardWeight) || 0);

        remainingPiecesTotal += remainingPieces;
        remainingWeightTotal += remainingWeight;
      });

      return {
        totalPieces: totalPieces,
        totalWeight: formatNumber(totalWeight),
        remainingPieces: remainingPiecesTotal,
        remainingWeight: formatNumber(remainingWeightTotal),
      };
    };

    const totals = calculateTotals();

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={this.columns1}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={this.columns1}
            data={this.state.stockList}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {`${this.props.t("Express - INWARD")}`}
                    </h3>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <div className="">
                              <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                                <h3 className="text-black fw-bold">
                                  {this.props.t("Express Inward List")}{" "}
                                </h3>
                              </div>

                              <div className="d-xxl-flex d-block justify-content-between text-center text-xxl-start">
                              <div className="pt-3 pt-xxl-0">
                                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-center">
                                  {/* Label */}
                                  <label
                                    htmlFor="dateFilterType"
                                    className="fs-5 pe-2 mb-2 mb-md-0"
                                    style={{ whiteSpace: "nowrap" }}
                                  >
                                    {this.props.t("Filter Date")}
                                  </label>

                                  {/* Dropdown */}
                                  <Select
                                    aria-labelledby="aria-label"
                                    className="officestock-select d-inline-block"
                                    inputId="aria-example-input"
                                    name="aria-live-color"
                                    onMenuOpen={this.onMenuOpen}
                                    onMenuClose={this.onMenuClose}
                                    value={DateFilter.find(
                                      option =>
                                        option.value ===
                                        this.state.dateFilterType
                                    ) || null}
                                    onChange={e => {
                                      const value = e.value;
                                      console.log("Selected Value:", value);

                                      localStorage.setItem(
                                        "sales_filter_dateFilterType",
                                        value
                                      );
                                      this.setState(
                                        {
                                          dateFilterType: value,
                                          stockList: [],
                                          page: 1,
                                        },
                                        () => this.getStockList()
                                      );
                                    }}
                                    options={DateFilter}
                                  />
                                </div>
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="fromDate"
                                  className="fs-5 fw-bold text-black pe-3"
                                >
                                  {this.props.t("From Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="fromDate"
                                  value={this.state.fromDate}
                                  onChange={e => {
                                    localStorage.setItem(
                                      "sales_filter_fromDate",
                                      e.target.value
                                    );
                                    this.setState(
                                      {
                                        stockList: [],
                                        fromDate: e.target.value,
                                      },
                                      () => this.getStockList()
                                    );
                                  }}
                                />
                                <label
                                  htmlFor="toDate"
                                  className="fs-5 fw-bold px-0 px-md-3 text-black"
                                >
                                  {this.props.t("To Date")}:
                                </label>
                                <input
                                  type="date"
                                  className="fs-5 text-black border-0"
                                  name="toDate"
                                  value={this.state.toDate}
                                  onChange={e => {
                                    localStorage.setItem(
                                      "sales_filter_toDate",
                                      e.target.value
                                    );
                                    this.setState(
                                      { stockList: [], toDate: e.target.value },
                                      () => this.getStockList()
                                    );
                                  }}
                                />
                              </div>

                                <div className="pt-3 pt-xxl-0">
                                  <p className="d-inline pe-3 fs-5">
                                    {this.props.t("Show")}
                                  </p>
                                  <div className="d-inline">
                                    <SizePerPageDropdownStandalone
                                      className=""
                                      {...paginationProps}
                                    />
                                  </div>

                                  <p className="d-inline ps-3 fs-5">
                                    {this.props.t("entries")}
                                  </p>
                              </div>
                            </div>

                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between mt-3">
                              <div className="search-box me-2 mb-2 ">
                                <div className="d-flex flex-column flex-md-row align-items-center align-items-md-center">
                                  {/* Label */}
                                  <label
                                    htmlFor="search"
                                    className="pt-2 fs-5 pe-1 pe-lg-3 mb-md-0"
                                    style={{ whiteSpace: "nowrap" }} // prevent label from wrapping
                                  >
                                    {this.props.t("Search Party")}
                                  </label>

                                  {/* Dropdown */}
                                  <AsyncSelect
                                    id="partyId"
                                    className="officestock-select d-inline-block"
                                    value={
                                      this.state.partyList
                                        .map(x => ({
                                          value: x.id,
                                          label: `${this.formatPartyCode(
                                            x.partyCode
                                          )} - ${x.name}`,
                                        }))
                                        .find(
                                          x => x.value === this.state.partyId
                                        ) || {
                                        label: "All",
                                        value: "",
                                      }
                                    }
                                    onChange={async e => {
                                      const value = e.value;
                                      localStorage.setItem(
                                        "sales_filter_partyId",
                                        value
                                      );
                                      await this.setState(
                                        {
                                          partyId: value,
                                          stockList: [],
                                          page: 1,
                                          sizePerPage: 100,
                                        },
                                        () => this.getStockList()
                                      );
                                    }}
                                    loadOptions={promiseOptions}
                                    defaultOptions={[
                                      { label: "All", value: "" },
                                      ...this.state.partyList.map(x => ({
                                        value: x.id,
                                        label: `${this.formatPartyCode(
                                          x.partyCode
                                        )} - ${x.name}`,
                                      })),
                                    ]}
                                  />
                                </div>
                              </div>

                              <div className="pt-3 pt-xxl-0">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <label
                                      htmlFor="search"
                                      className="pt-2 fs-5 pe-1 pe-lg-3"
                                    >
                                      {this.props.t("Search Jangad")}
                                    </label>
                                    <AsyncSelect
                                      id="jangadId"
                                      className="officestock-select d-inline-block"
                                      value={
                                        this.state.orderList.find(
                                          option =>
                                            option.value === this.state.jangadId
                                        ) || null
                                      }
                                      onChange={async e => {
                                        const value = e.value;
                                        localStorage.setItem(
                                          "sales_filter_jangadId",
                                          value
                                        );
                                        await this.setState({
                                          jangadId: e.value,
                                          stockList: [],
                                          page: 1,
                                          sizePerPage: 100,
                                        });
                                        this.getStockList();
                                      }}
                                      loadOptions={promiseOptionsOrder}
                                      defaultOptions={this.state.orderList}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="d-xxl-flex d-block text-center text-xxl-start justify-content-between mb-2">
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="search"
                                  className="pt-2 fs-5 pe-1 pe-lg-3"
                                >
                                  {this.props.t("Outward Status")}
                                </label>

                                <Select
                                  onChange={e => {
                                    const value = e.value;
                                    localStorage.setItem(
                                      "sales_filter_outWardStatus",
                                      value
                                    );
                                    this.setState(
                                      {
                                        outWardStatus: e.value,
                                        stockList: [],
                                        page: 1,
                                        sizePerPage: 100,
                                      },
                                      () => {
                                        this.getStockList().then(() => {});
                                      }
                                    );
                                  }}
                                  aria-labelledby="aria-label"
                                  className="officestock-select d-inline-block"
                                  inputId="aria-example-input"
                                  name="aria-live-color"
                                  onMenuOpen={this.onMenuOpen}
                                  onMenuClose={this.onMenuClose}
                                  value={outWardStatus.find(
                                    option =>
                                      option.value === this.state.outWardStatus
                                  )}
                                  options={outWardStatus}
                                />
                              </div>
                              <div className="pt-3 pt-xxl-0">
                                <label
                                  htmlFor="barcodeInput"
                                  className="pt-2 fs-5 pe-1 pe-lg-3 mb-2 mb-md-0"
                                >
                                  {this.props.t("Scan Barcode")}
                                </label>

                                <input
                                  type="text"
                                  id="barcodeInput"
                                  className="form-gray ps-2 mb-2 mb-md-0 py-2"
                                  value={this.state.scannedBarcode}
                                  onChange={this.handleBarcodeScan}
                                  onKeyDown={e => {
                                    if (e.key === "Enter") {
                                      this.handleBarcodeScan(e);
                                    }
                                  }}
                                  placeholder=""
                                />
                              </div>
                            </div>
                            <Row className="mb-3 g-2">
                              <Col xs={12} sm={6} md={2}>
                                <Button
                                  className="w-100 fs-5 py-2"
                                  color="primary"
                                  onClick={this.refreshList}
                                >
                                  {this.props.t("Refresh")}
                                </Button>
                              </Col>
                              <Col xs={12} sm={6} md={2}>
                                <Button
                                  className="w-100 fs-5 py-2"
                                  color="primary"
                                  onClick={this.resetAll}
                                >
                                  {this.props.t("Reset")}
                                </Button>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                <div
                                  className="table-responsive"
                                  style={{ overflowX: "auto", width: "100%" }}
                                >
                                  <BootstrapTable
                                    remote={true}
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    data={this.state.stockList}
                                    columns={this.columns1}
                                    rowClasses={rowClasses}
                                    classes={
                                      "table align-middle table-nowrap table-collapsed table-collapse"
                                    }
                                    headerWrapperClasses={"thead-light"}
                                    onTableChange={() => false}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                              <div className="">
                                <h5>
                                  {this.props.t("Showing")}{" "}
                                  {(this.state.page - 1) *
                                    this.state.sizePerPage +
                                    1}{" "}
                                  -{" "}
                                  {this.state.totalSize < this.state.sizePerPage
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                        this.state.page >=
                                      this.state.totalSize
                                    ? this.state.totalSize
                                    : this.state.sizePerPage *
                                      this.state.page}{" "}
                                  of {this.state.totalSize}
                                </h5>
                              </div>
                              <div className="ms-auto">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
                <Modal
                  isOpen={this.state.showBarcodeModal}
                  toggle={() => this.toggleBarcodeModal(null)}
                  centered
                >
                  <ModalHeader toggle={() => this.toggleBarcodeModal(null)}>
                    Print Barcode
                  </ModalHeader>
                  <ModalBody className="text-center">
                    {this.state.selectedJangadId && (
                      <>
                        <div
                          style={{
                            width: "189px",
                            height: "95px",
                            padding: "4px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            boxSizing: "border-box",
                            textAlign: "center",
                          }}
                          ref={this.barcodeRef}
                          id="barcodeContainer"
                        >
                          <Barcode
                            value={`JANGAD${this.state.selectedJangadId}`}
                            width={1.4}
                            height={45}
                            displayValue={false}
                            textMargin={0}
                            margin={0}
                          />
                          <p style={{ fontSize: "14px", marginBottom: "0px" }}>
                            JN: {`${this.state.selectedJangad.jangadId}`},
                            Party:{" "}
                            {this.state.selectedJangad.party
                              ? `${this.formatPartyCode(
                                  this.state.selectedJangad.party.partyCode
                                )}`
                              : ""}
                            <br />
                            Total pcs: {this.state.selectedJangad?.noOfPieces},
                            Total Cts: {this.state.selectedJangad?.totalWeight},
                          </p>
                        </div>
                      </>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => this.toggleBarcodeModal(null)}
                    >
                      Close
                    </Button>
                    <Button color="primary" onClick={printBarcodeOnly}>
                      Print
                    </Button>
                  </ModalFooter>
                </Modal>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(ExpressInwardList);
